import ar from '../../locales/ar.json'

const steps = Object.entries(ar.steps).map(([k, v]) => ({ number: Number(k), ...v }))

export default function StepIndicator({ currentStep, onStepClick }) {
  return (
    <nav aria-label="خطوات النموذج" className="mb-8">
      {/* Mobile: compact pills */}
      <div className="flex items-center justify-center gap-1.5 sm:hidden">
        {steps.map((s) => (
          <button
            key={s.number}
            onClick={() => onStepClick?.(s.number)}
            disabled={!onStepClick || s.number > currentStep}
            aria-label={s.title}
            aria-current={s.number === currentStep ? 'step' : undefined}
            className={`w-8 h-8 rounded-full text-xs font-bold transition-all
              ${s.number === currentStep
                ? 'bg-gold text-white shadow-md scale-110'
                : s.number < currentStep
                ? 'bg-primary-700 text-white cursor-pointer hover:bg-primary-600'
                : 'bg-stone-200 text-stone-400 cursor-not-allowed'
              }`}
          >
            {s.number}
          </button>
        ))}
      </div>

      {/* Desktop: full step indicator */}
      <div className="hidden sm:flex items-center">
        {steps.map((s, idx) => (
          <div key={s.number} className="flex items-center flex-1 last:flex-none">
            {/* Step dot + label */}
            <div className="flex flex-col items-center">
              <button
                onClick={() => onStepClick?.(s.number)}
                disabled={!onStepClick || s.number > currentStep}
                aria-label={s.title}
                aria-current={s.number === currentStep ? 'step' : undefined}
                className={`step-indicator-dot w-10 h-10 rounded-full flex items-center justify-center
                  font-bold text-sm border-2 transition-all
                  ${s.number === currentStep
                    ? 'border-gold bg-gold text-white shadow-lg scale-110'
                    : s.number < currentStep
                    ? 'border-primary-700 bg-primary-700 text-white cursor-pointer hover:bg-primary-600'
                    : 'border-stone-300 bg-white text-stone-400 cursor-not-allowed'
                  }`}
              >
                {s.number < currentStep ? (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  s.number
                )}
              </button>
              <span
                className={`mt-1.5 text-xs font-medium text-center max-w-[80px] leading-tight
                  ${s.number === currentStep ? 'text-gold-dark' : s.number < currentStep ? 'text-primary-700' : 'text-stone-400'}`}
              >
                {s.title}
              </span>
            </div>

            {/* Connector line */}
            {idx < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-2 mb-5 transition-all duration-300
                  ${s.number < currentStep ? 'bg-primary-600' : 'bg-stone-200'}`}
              />
            )}
          </div>
        ))}
      </div>

      {/* Step counter for mobile */}
      <div className="sm:hidden text-center mt-2 text-sm text-stone-500">
        الخطوة {currentStep} من {steps.length}: <strong className="text-primary-700">{ar.steps[currentStep]?.title}</strong>
      </div>
    </nav>
  )
}
